import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import {
  AlertModule,
  EmptyStateModule,
  LoaderModule,
  MainContentModule,
  ModalModule,
  SidebarModule,
  StatusModule,
  TableModule
} from '@michelin/theme';
import { SharedModule } from 'src/app/shared/shared.module';
import { ActionDetailsComponent } from './components/action-details/action-details.component';
import { NtrAgeComponent } from './components/ntr-age/ntr-age.component';
import { RepairLimitComponent } from './components/repair-limit/repair-limit.component';
import { SpecLineDefinitionComponent } from './components/spec-line-definition/spec-line-definition.component';

@NgModule({
  declarations: [SpecLineDefinitionComponent, NtrAgeComponent, RepairLimitComponent, ActionDetailsComponent],
  exports: [SpecLineDefinitionComponent, NtrAgeComponent, RepairLimitComponent, ActionDetailsComponent],
  imports: [
    CommonModule,
    TableModule,
    EmptyStateModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    StatusModule,
    SidebarModule,
    AlertModule,
    LoaderModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    ModalModule,
    MainContentModule
  ]
})
export class AssetManagementModule {}
